export const MIN_BPM = 30;
export const MAX_BPM = 500;
export const SPIN_ANIMATION_DURATION = 1000;
export const METRONOME_LOOKAHEAD_SECOND = 0.05;
export const METRONOME_LOOKAHEAD_MS = METRONOME_LOOKAHEAD_SECOND * 1000;

// Total ms tolerance for a note hit to count; outside this it's a miss.
export const HIT_WINDOW_MS = 150;
// Within this tolerance a hit is Perfect; between this and HIT_WINDOW_MS it's Good.
export const PERFECT_MS = 80;

// Tempo ranges based on time signature denominator
export const TEMPO_RANGES = {
  4: { min: 50, max: 200 },
  8: { min: 100, max: 400 },
  16: { min: 200, max: 500 }
} as const;

export const getSectionColors = () => {
  const styles = getComputedStyle(document.documentElement);
  return [
    styles.getPropertyValue('--color-section-1').trim(),
    styles.getPropertyValue('--color-section-2').trim(),
    styles.getPropertyValue('--color-section-3').trim(),
    styles.getPropertyValue('--color-section-4').trim(),
    styles.getPropertyValue('--color-section-5').trim(),
    styles.getPropertyValue('--color-section-6').trim(),
    styles.getPropertyValue('--color-section-7').trim(),
    styles.getPropertyValue('--color-section-8').trim(),
  ];
};
